import CoconeuseBioTemplate from "../../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseDeborahValouse = () => (
  <CoconeuseBioTemplate
    name="Deborah"
    subtitle="Éveil · Harmonisation · Paix intérieure · Transformation"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/6r9rpmdm_DSC01487.jpg"
    bioText={[
      "Deborah est un pont entre l'universel et l'intime.",
      "Elle accompagne des espaces où l'invisible devient perceptible, et où chacun·e peut renouer avec sa propre clarté.",
      "Son approche invite à délier ce qui entrave, à apaiser les tensions invisibles, et à retrouver un espace intérieur plus juste.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/aktwmscl_DSC00955.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/44b3o3mj_DSC01494.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/zb7dse9c_DSC01437.jpg",
    ]}
    expertise={["Transformation énergétique", "Lecture du mental", "Clarté intérieure"]}
    backPath="/coconeuses#profil-deborah"
    backLabel="Retour aux Coconeuses"
  />
);

export default CoconeuseDeborahValouse;
